$(document).ready(() => {
    $('[data-toggle-targets]').on('click', (e) => {
        const targets = e.currentTarget.dataset.toggleTargets.split(' ');
        targets.forEach((selector) => {
            $(selector).toggle();
        });
    });
});
